import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { ClaimToolElement } from "@shared/models/claim-tool-element.model";
import { DataElement, PhraseWord } from "@shared/models/common";
import { SplitPhrase } from "@shared/models/split-phrase.model";
import { NgRedux } from "@shared/redux/redux-compatibility.service";
import { AppState } from "@shared/redux/store";
import { ClaimToolService } from "@shared/services/claim-tool.service";
import { Popover } from "primeng/popover";

export interface SplitPhraseDisplay {
        split_word_id: number;
      phrase_words: PhraseWord[];
      phrase_content_type: string;
}
@Component({
    selector: 'split-phrase',
    templateUrl: './split-phrase.component.html',
    styleUrls: ['./split-phrase.component.scss'],
    standalone: false
})
export class SplitPhraseComponent implements OnInit {

    @Input() phraseWords: PhraseWord[];
    selectedWords: PhraseWord[] = [];

    @Input() phraseDispWords: PhraseWord[];

    @Input() disabled: boolean = false;

    @Input() contentType: string;

    @Input() contentTypeDesc: string;

    newPhrases:  SplitPhraseDisplay[] = [];

    contentTypeOptions: DataElement[] = [];
    @ViewChild('overlay') contentTypesOverlay: Popover;

    constructor(private ngRedux: NgRedux<AppState>, private claimToolService: ClaimToolService) {
      
    }

    ngOnInit(): void {
      
      this.contentTypeOptions = this.ngRedux.getState().contentTypeList;
    }

  get claimToolElement(): ClaimToolElement {

    return this.ngRedux.getState().claimToolElement;

  }
 onCheckboxChange(event: Event, option: PhraseWord): void {
    const isChecked = (event.target as HTMLInputElement).checked;

    if (isChecked) {
      this.selectedWords.push(option);
    } else {
      this.selectedWords = this.selectedWords.filter(o => o !== option);
    }

    // 🔔 Callback logic
    this.splitBySelectedWords();
  }

  changeType(splitPhrase: SplitPhraseDisplay, contentType: DataElement) {
    //this.claimToolElement.splitPhrases
    splitPhrase.phrase_content_type = contentType.label;
    let splitPhrases = this.claimToolElement.splitPhrases;

    let phrase: SplitPhrase = splitPhrases.find(splittedPhrase => splittedPhrase.split_word_id == splitPhrase.split_word_id);

    phrase.phrase_content_type = contentType.id;
    if (this.contentTypesOverlay) {
      this.contentTypesOverlay.hide();
    }
  }

  splitBySelectedWords() {

    this.newPhrases = [];
    if (this.selectedWords.length == 0) {
      this.claimToolService.splitWordsChanged$.next(false);
      this.claimToolElement.splitPhrases = [];
      return;
    }
    let splittingIndexes: {
      split_word_id: number;
      index: number;
    }[] = [];
    let splittedPhrases: SplitPhrase[] = [];
    splittingIndexes.push({
      split_word_id: this.phraseWords[0].id,
      index: 0
    
    });

    //find index of all selected words in array
    for (let i=0; i<this.selectedWords.length; i++) {
      
      let curWord: PhraseWord = this.selectedWords[i];

      let indexOfPhraseWord = this.phraseWords.findIndex(word => word.id == curWord.id);
      splittingIndexes.push({
        split_word_id: curWord.id,
        index: indexOfPhraseWord

      });
      splittedPhrases.push({
        split_word_id: curWord.id,
        phrase_content_type: this.contentType
      });
    }
    //sort indexes ascending [0, 3, 5]
    splittingIndexes.sort((a, b) => a.index - b.index);
    
    //create new phrases from split
    for (let i=0; i<splittingIndexes.length; i++) {
      let curIndex = splittingIndexes[i].index;
      let nextIndex: number = this.phraseWords.length;

      if (i != splittingIndexes.length-1) {
        nextIndex = splittingIndexes[i+1].index;
      }
      let newWord: PhraseWord[] = [];
      for (let j=curIndex; j<nextIndex; j++) {
        newWord.push(this.phraseWords[j]);

      }
      this.newPhrases.push({
        split_word_id: splittingIndexes[i].split_word_id,
        phrase_words: newWord,
        phrase_content_type: this.contentTypeDesc
      });
    }
    this.claimToolElement.splitPhrases = splittedPhrases;
    this.claimToolService.splitWordsChanged$.next(true);
  }
}